import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInAslAssetObject = (asset, configurations, alias) => {
    const updatedAsset = deepCopyObject(asset);
    updatedAsset.assetDetails.alias = chainWalk(() => alias.toString(), "");
    updatedAsset.assetDetails.assetAttributes.divertConfig =
        chainWalk(() => JSON.stringify(configurations.divertConfig), "[]")
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/asldevice/datamodel/AslAssetModelResource.js